var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setScorePage"},[_c('div',{staticClass:"pageCont"}),_c('div',{staticClass:"bottom-button"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.setSubmit}},[_vm._v("确定")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }